import React from 'react';
import style from './index.scss';

import { Breadcrumb } from 'antd';

const BreadCrumb = ({ crumbs = [] }) => {
  return (
    <div className={style.container}>
      <Breadcrumb>
        {crumbs.map((crumb, idx) => {
          let params = {};
          if (crumb.linkTo) params.href = crumb.linkTo;

          return (
            <Breadcrumb.Item className={style.crumb} {...params} key={idx}>
              {crumb.label}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    </div>
  );
};

export default BreadCrumb;
